import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Box, TextField, Typography } from "@mui/material";
import { toast } from "react-toastify";

import { LayoutContainer, LayoutWrapper, LogoComponent } from "../components";
import { ButtonMGPrimary } from "../components/buttons";
import { cleanUserSession, resetUserSessionDummy, setUserUpdateSession } from "../state/actions";
import LoadingContext from "../context/LoadingProvider";
import { validation } from "../utils";
import SessionService from "../services/SessionService";

const RecoverPassword = () => {
  const [values, setValues] = useState({ email: "", remember: false, });

  const { setLoadingValue } = useContext(LoadingContext)

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleChange = (prop: string) => (event: any) =>
    setValues({ ...values, [prop]: event.target.value.toLowerCase() });

  const recoverPassword = () => {
    try {
      setLoadingValue(true)
      dispatch(setUserUpdateSession(null));
      SessionService.postAccountRecovery({ login: values.email })
        .then((res) => {
          if (res.status === '400'){
            toast(res.message || "Error al recuperar la contraseña")
            return;
          }
          dispatch(cleanUserSession())
          dispatch(resetUserSessionDummy())
          toast("Revise su email para continuar con la recuperación de su contraseña")
          navigate("/")
        })
        .finally(() => setLoadingValue(false))
    } catch (error) { console.error(error) }
  };

  return (
    <LayoutContainer>
      <LayoutWrapper>
        <>
          <LogoComponent />
          <Typography component="h1" variant="h5">
            Ingrese su email para recuperar su contraseña
          </Typography>

          <Box component="form" noValidate sx={{ mt: 1 }}>
            <TextField
              autoFocus
              margin="normal"
              required
              fullWidth
              id="email"
              label="Ingrese su email"
              name="email"
              value={values.email}
              autoComplete="email"
              onChange={handleChange("email")}
              error={!validation("email", values.email) && !!values.email}
            />

            <ButtonMGPrimary
              title="Continuar"
              action={recoverPassword}
              disabled={!validation("email", values.email)}
            />
          </Box>
        </>
      </LayoutWrapper>
    </LayoutContainer>
  )
};


export default RecoverPassword;
